import type { S3 } from '@aws-sdk/client-s3';
import * as React from 'react';

export const AnalyticsAccountS3ClientContext = React.createContext<S3 | null>(null);

/** Get the Analytics Account S3 client */
export function useAnalyticsAccountS3Client(): S3 | null {
  return React.useContext(AnalyticsAccountS3ClientContext);
}
